import React, { useContext, useReducer } from 'react';
import { User } from '@hydra/types';

interface UserContext {
  user: User | null
}

const UserContext = React.createContext<UserContext>({
  user: null
});

function userReducer (user: User) {
  return user;
}

interface UserProviderProps {
  user: User
  children: React.ReactNode
}

export const UserProvider = ({ user, children }: UserProviderProps) => {
  const [value] = useReducer(userReducer, user);
  return (
    <UserContext.Provider value={{ user: value }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);

export default UserContext;
